import React from 'react';
import { ReportList } from './ReportList';
import { ReportDetails } from './ReportDetails';
import { useReportContext } from './ReportContext';

interface ReportsProps {
  className: string;
}

export const Reports = React.memo(({ className }: ReportsProps) => {
  const { selectedJob, selectedReportTemplate } = useReportContext();

  if (selectedJob && selectedReportTemplate) {
    return <ReportDetails className={className} />;
  }

  return <ReportList className={className} />;
});

Reports.displayName = 'Reports';
